/**
 * Opening the browser print dialog.
 *
 * A one-line wrapper around `window.print`, and it exists for the same reason
 * `download.ts` does: jsdom defines `window.print` as non-configurable, so a
 * component calling it directly cannot be tested — the call can be neither
 * spied nor asserted. Routing it through a module boundary lets a test stub
 * this function and observe that the button triggered a print.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 10.3, PRD F17
 */
export function printPage(): void {
  window.print();
}
